import React from 'react';
import {connect} from 'react-redux';
import debug from 'debug';
import PropTypes from 'prop-types';
import Column from '../Column';
import PrefCore from './PrefCore';
import Icon from '../Icon';
import {_openModal} from '../../reducers/modals';
import {DescriptiveText} from '../../index';
import Row from '../Row';

const log = debug('circleblack:preferences:group');

function PrefGroup({group, updateCore, panel, openModal, preferenceButtons, preferenceCheckboxes}) {
  log('rendering');

  const style = group.col !== 12 ? {
    minWidth: group.col * 75 + 'px',
    maxWidth: group.col * 100 + 'px',
  } : {};

  if (group.masterPrefID) {
    group.masterPref = panel.cores[panel.coresID[group.masterPrefID].title];
  }
  if (group.enablingPrefID) {
    group.enablingPref = panel.cores[panel.coresID[group.enablingPrefID].title];
  }

  return <Column {...style} layout={{grow: 1}} alignItems={'left'} margin={'5px'}>
    {group.displayName && <Row justifySubRow={'left'}>
      <DescriptiveText preset={'dataLabelLarge'}>{group.displayName}</DescriptiveText>{group.description
    && <Icon svg={'help'}
             height={'20px'}
             width={'20px'}
             action={() => openModal({
               type: 'MessageModal',
               title: group.displayName,
               body: group.description,
             })}/>}
    </Row>}
    {group.cores.map(c => <PrefCore key={`core-${c.id}`}
                                    core={panel.cores[c.title]}
                                    updateCore={updateCore}
                                    group={group}
                                    preferenceButtons={preferenceButtons}
                                    preferenceCheckboxes={preferenceCheckboxes}
                                    panel={panel}/>)}
  </Column>;
}

const mapDispatchToProps = dispatch => ({
  openModal: modal => dispatch(_openModal(modal)),
});

export default connect(null, mapDispatchToProps)(PrefGroup);

PrefGroup.propTypes = {
  group: PropTypes.shape({
    displayName: PropTypes.string,
    description: PropTypes.string,
    /**
     * Number of 'columns' wide. Min width 75*col, max 100*col in PX, if col is 12, then defaults are used.
     */
    col: PropTypes.number,
    masterPrefID: PropTypes.number,
    /**
     * Set based on enablingPrefID
     */
    masterPref: PropTypes.object,
    enablingPrefID: PropTypes.number,
    /**
     * Set based on enablingPrefID
     */
    enablingPref: PropTypes.object,
    cores: PropTypes.array,
  }).isRequired,
  panel: PropTypes.shape({
    /**
     * Cores indexed by Title
     */
    cores: PropTypes.object.isRequired,
    /**
     * Cores indexed by ID
     */
    coresID: PropTypes.object.isRequired,
  }).isRequired,
  /**
   * Pass-through to PrefCore
   */
  updateCore: PropTypes.func.isRequired,
  openModal: PropTypes.func,
  /**
   * Pass-through to PrefCore
   */
  preferenceButtons: PropTypes.object,
  /**
   * Pass-through to PrefCore
   */
  preferenceCheckboxes: PropTypes.object,
};
